export interface TabConfig {
  id: string
  name: string
  requiresScreenshots: boolean
  renderDelay?: number
}

export const TAB_CONFIGS: TabConfig[] = [
  { id: 'executive-summary', name: 'Executive Summary', requiresScreenshots: true, renderDelay: 500 },
  { id: 'market-analysis', name: 'Analysis & Strategy', requiresScreenshots: false, renderDelay: 300 },
  { id: 'personas', name: 'Personas', requiresScreenshots: false, renderDelay: 300 },
  { id: 'media-plan', name: 'Media Plan', requiresScreenshots: false, renderDelay: 300 },
  { id: 'projections', name: 'Projections', requiresScreenshots: true, renderDelay: 2000 }
]

export class TabNavigationHelper {
  private currentTabId: string | null = null

  async navigateToTab(tabId: string, onTabChange: (tabId: string) => void): Promise<void> {
    return new Promise(resolve => {
      this.currentTabId = tabId
      onTabChange(tabId)

      const tabConfig = TAB_CONFIGS.find(config => config.id === tabId)
      const delay = tabConfig?.renderDelay || 500

      setTimeout(resolve, delay)
    })
  }

  async waitForTabContent(tabId: string, additionalDelay: number = 0): Promise<void> {
    const tabConfig = TAB_CONFIGS.find(config => config.id === tabId)
    const totalDelay = (tabConfig?.renderDelay || 500) + additionalDelay

    return new Promise(resolve => setTimeout(resolve, totalDelay))
  }

  getCurrentTabId(): string | null {
    return this.currentTabId
  }
}
